import axios from 'axios';
import { REEBELO_DOMAINS } from '@lambda/reebelo';
import { ProductReviewsT } from '@/settings/types';
import { logger } from './logger';
import settings from '@/settings';

export const generateReviewDisplayName = (name: string) => {
  const nameArr = name.split(' ').filter(Boolean);

  return nameArr.length > 1 ? `${nameArr[0]} ${nameArr[1][0]}.` : nameArr[0];
};

export async function getProductReviews({
  psku,
  lastIndex,
  batchSize,
}: {
  psku: string;
  lastIndex?: number;
  batchSize?: number;
}) {
  const domain =
    process.env.STAGE === 'dev'
      ? 'localhost:3000'
      : REEBELO_DOMAINS[settings.store];

  const protocol = process.env.STAGE === 'dev' ? 'http' : 'https';
  let url = `${protocol}://${domain}/api/collections/reviews?psku=${encodeURIComponent(
    psku,
  )}`;

  if (lastIndex) {
    url += `&lastIndex=${lastIndex}`;
  }

  if (batchSize) {
    url += `&batchSize=${batchSize}`;
  }

  try {
    const { data } = await axios.get<ProductReviewsT>(url);

    return data;
  } catch (error) {
    logger.error(
      { error, domain, protocol, url },
      'error fetching product reviews',
    );

    return null;
  }
}
